import type { Database } from "@asap/shared/types/supabase.gen";
import { createSharedComposable } from "@vueuse/core";
export const useSupabase = createSharedComposable(() => {
  return useSupabaseClient<Database>();
});
